module.exports = __webpack_public_path__ + "static/Logo-InnovationLab_Blue-a3e27a4521580ecb5fbd73c0c16424d0.svg";